var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _ellipse, _path2, _ellipse2, _ellipse3, _path3, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgEmptyPayments = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 330,
    height: 222,
    fill: "none",
    viewBox: "0 0 330 222",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8799A8",
    d: "M91 102l70.167-45.208c2.639-1.7 6.027-1.7 8.666 0L240 102v76c0 4.418-3.582 8-8 8H99c-4.418 0-8-3.582-8-8v-76z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 119,
    height: 108,
    x: 106,
    y: 44,
    fill: "#fff",
    stroke: "#8799A8",
    strokeWidth: 2,
    rx: 7
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    x: 123,
    y: 61,
    fill: "#DDE2EB",
    rx: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 4,
    x: 162,
    y: 61,
    fill: "#EBEFF5",
    rx: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 4,
    x: 162,
    y: 73,
    fill: "#EBEFF5",
    rx: 2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 4,
    x: 162,
    y: 97,
    fill: "#EBEFF5",
    rx: 2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 4,
    x: 162,
    y: 85,
    fill: "#EBEFF5",
    rx: 2
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 4,
    x: 162,
    y: 109,
    fill: "#EBEFF5",
    rx: 2
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 4,
    x: 123,
    y: 97,
    fill: "#EBEFF5",
    rx: 2
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 4,
    x: 123,
    y: 109,
    fill: "#EBEFF5",
    rx: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 165.5,
    cy: 184,
    fill: "#E8E8E8",
    opacity: 0.5,
    rx: 84.5,
    ry: 8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAFBFC",
    stroke: "#8799A8",
    strokeWidth: 2,
    d: "M239 105.03V178c0 3.866-3.134 7-7 7H99c-3.866 0-7-3.134-7-7v-72.97c.807 1.035 1.879 2.355 3.208 3.878 3.305 3.786 8.208 8.831 14.61 13.877C122.619 132.875 141.457 143 165.5 143c24.043 0 42.881-10.125 55.682-20.215 6.402-5.046 11.305-10.091 14.61-13.877 1.329-1.523 2.401-2.843 3.208-3.878z"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.985,
    cy: 99.543,
    fill: "#DDE2EB",
    rx: 4.985,
    ry: 4.979
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 294.48,
    cy: 216.684,
    fill: "#DDE2EB",
    rx: 4.675,
    ry: 4.666
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#596C80",
    strokeWidth: 3,
    d: "M53.606 187.536c0 3.883-3.155 7.036-7.053 7.036s-7.053-3.153-7.053-7.036c0-3.883 3.155-7.036 7.053-7.036s7.053 3.153 7.053 7.036z"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    width: 2.491,
    height: 6.851,
    fill: "#6F8194",
    rx: 1.246,
    transform: "rotate(-44.944 58.512 -63.564)"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    width: 2.491,
    height: 6.851,
    fill: "#6F8194",
    rx: 1.246,
    transform: "rotate(-44.944 76.198 -70.92)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 2.491,
    height: 6.851,
    fill: "#6F8194",
    rx: 1.246,
    transform: "rotate(44.978 13.244 103.757)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 2.491,
    height: 6.851,
    fill: "#6F8194",
    rx: 1.246,
    transform: "rotate(44.944 -4.463 96.478)"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 2.567,
    height: 6.596,
    x: 318.823,
    y: 100.606,
    fill: "#6F8194",
    rx: 1.283
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 2.567,
    height: 6.596,
    x: 318.823,
    y: 111.934,
    fill: "#6F8194",
    rx: 1.283
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 2.399,
    height: 7.059,
    x: 330,
    y: 108.588,
    fill: "#6F8194",
    rx: 1.199,
    transform: "rotate(90 330 108.588)"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 2.399,
    height: 7.059,
    x: 317.119,
    y: 108.588,
    fill: "#6F8194",
    rx: 1.199,
    transform: "rotate(90 317.119 108.588)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#DDE2EB",
    strokeWidth: 3,
    d: "M256.223 7.347c0 3.227-2.621 5.847-5.861 5.847-3.24 0-5.862-2.62-5.862-5.847 0-3.226 2.622-5.847 5.862-5.847s5.861 2.62 5.861 5.847z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#596C80",
    d: "M139.987 78.657c.006-.593-.466-.913-1.167-1.166l-.022 2.337c.82-.188 1.184-.629 1.189-1.17zm-2.777-4.075l.022-2.405c-.869.205-1.216.697-1.222 1.256-.005.593.483.914 1.2 1.149zm1.567 7.481l-.017 1.897-1.636.003.017-1.845c-1.619-.099-3.168-.62-4.061-1.346l.918-2.068c.813.625 1.986 1.08 3.164 1.195l.026-2.828c-1.812-.453-3.835-1.075-3.813-3.497.017-1.795 1.29-3.339 3.878-3.649l.017-1.88 1.636-.003-.016 1.846c1.225.099 2.416.435 3.311 1.025L141.364 73c-.83-.49-1.678-.776-2.495-.876l-.027 2.879c1.812.436 3.803 1.059 3.78 3.446-.016 1.762-1.273 3.288-3.845 3.615z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEmptyPayments, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/emptyPayments.74e6cf90.svg";
export { ForwardRef as ReactComponent };